import "../../assets/style/Demo.css";

import Topbar from "../../component/Topbar/Topbar";
import Footer from "../../component/Footer/Footer";
import { Link } from "react-router-dom";

import arrow from "../../assets/icon/arrowRight.svg";

import women from "../../assets/photo/demoWomen.webp";
import fr1 from "../../assets/photo/frame1.webp";
import fr2 from "../../assets/photo/frame2.webp";
import fr3 from "../../assets/photo/frame3.webp";
import fr4 from "../../assets/photo/frame4.webp";

import aiic1 from "../../assets/icon/aiic1.svg";
import aiic2 from "../../assets/icon/aiic2.svg";
import aiic3 from "../../assets/icon/aiic3.svg";
import aiic4 from "../../assets/icon/aiic4.svg";
import aiic5 from "../../assets/icon/aiic5.svg";
import aiic6 from "../../assets/icon/aiic6.svg";
import aiic7 from "../../assets/icon/aiic7.svg";

import pb1 from "../../assets/photo/pb1.webp";
import pb2 from "../../assets/photo/pb2.webp";
import pb3 from "../../assets/photo/pb3.webp";
import pb6 from "../../assets/photo/pb6.webp";


import hair1 from "../../assets/photo/hair11.webp"
import hair2 from "../../assets/photo/hair2.webp"
import telkom1 from "../../assets/photo/telkom11.webp"
import telkom2 from "../../assets/photo/telkom2.webp"
import telkomaci1 from "../../assets/photo/telkomaci11.webp"
import telkomaci2 from "../../assets/photo/telkomaci2.webp"
import mtf1 from "../../assets/photo/mtf11.webp"
import mtf2 from "../../assets/photo/mtf2.webp"
import { useTranslation } from "react-i18next";

const balikAtas = () => {
    document.body.scrollIntoView({
        behavior: "smooth",
    });
};

function Demo(params) {
    const { t } = useTranslation();

    const listPicture = [{
        src: fr1,
        no: 1
    },
    {
        src: fr2,
        no: 2
    },
    {
        src: fr3,
        no: 3
    },
    {
        src: fr4,
        no: 4
    }];

    const listCapability1 = [{
        tag: "Language",
        title: "Natural Language Processing",
        text: t("hpc4product1"),
        icon: aiic1,
        link: "/nlp"
    },
    {
        tag: "Voice",
        title: "Voice Cloning",
        text: t("hpc4product2"),
        icon: aiic2,
        link: "/voice-cloning"
    },
    {
        tag: "Voice",
        title: "Voice Separation",
        text: t("hpc4product3"),
        icon: aiic3,
        link: "/voice-separation"
    }];

    const listCapability2 = [
    {
        tag: "Image",
        title: "Custom Image Classification",
        text: t("hpc4product4"),
        icon: aiic4,
        link: "/custom-image-classification"
    },
    {
        tag: "Image",
        title: "Image Similarity",
        text: t("hpc4product5"),
        icon: aiic5,
        link: "/custom-image-similarity"
    },
    {
        tag: "Image",
        title: "Optical Character Recognition",
        text: t("hpc4product6"),
        icon: aiic6,
        link: "/ocr"
    }];

    const listCapability3 = [
    {
        tag: "Design",
        title: "3D",
        text: t("hpc4product7"),
        icon: aiic7,
        link: "/3d-motion"
    }];

    const listCapability = [
        {
            tag: "Language",
            title: "Natural Language Processing",
            text: t("hpc4product1"),
            icon: aiic1,
            link: "/nlp"
        },
        {
            tag: "Voice",
            title: "Voice Cloning",
            text: t("hpc4product2"),
            icon: aiic2,
            link: "/voice-cloning"
        },
        {
            tag: "Voice",
            title: "Voice Separation",
            text: t("hpc4product3"),
            icon: aiic3,
            link: "/voice-separation"
        },
        {
            tag: "Image",
            title: "Custom Image Classification",
            text: t("hpc4product4"),
            icon: aiic4,
            link: "/custom-image-classification"
        },
        {
            tag: "Image",
            title: "Image Similarity",
            text: t("hpc4product5"),
            icon: aiic5,
            link: "/custom-image-similarity"
        },
        {
            tag: "Image",
            title: "Optical Character Recognition",
            text: t("hpc4product6"),
            icon: aiic6,
            link: "/ocr"
        },
        {
            tag: "Design",
            title: "3D",
            text: t("hpc4product7"),
            icon: aiic7,
            link: "/3d-motion"
        }
    ]

    const listCaseStudies = [
        {
            img: pb1, // GRO TRACK
            judul: "GRO Technologies",
            text: 'Skin & Hair Clinic',
            // link:  "learnmore",
            text1: "Solusi AI untuk Analisis & Perawatan Rambut",
            text2: "Infidea berkolaborasi dengan GRO Technology untuk menghadirkan AI canggih yang mampu mendeteksi kebotakan, melacak pertumbuhan rambut, dan menganalisis wajah dengan presisi tinggi.",
            img1: hair1,
            impact: "Hasil treatment pasien lebih akurat dengan menggunakan platform tersebut",
            problem1: "Kesulitan dalam Memantau Perkembangan Treatment Pasien",
            problem2: "Klinik/dokter sering kesulitan dalam membandingkan hasil perawatan pasien dari waktu ke waktu sehingga konsultasi treatment tidak akurat.",
            solution1: "Mengembangkan model AI untuk membantu memantau perkembangan treatment",
            solution2: "Dengan teknologi GroTrack, platform ini memungkinkan pemantauan dan analisis perubahan estetika secara komprehensif dan realtime.",
            img2: hair2,
            background: "Grotech.ai adalah perusahaan yang menawarkan solusi pencitraan estetika total untuk rambut, wajah, dan tubuh. Mereka menyediakan perangkat AI portable yang dirancang untuk berbagai prosedur estetika, termasuk analisis pertumbuhan rambut, pencitraan wajah standar, dan pencitraan tubuh untuk penghilangan rambut dan tato. Perangkat ini juga dilengkapi dengan asisten AI untuk wawancara pasien dan pencatatan klinis. Saat ini, lebih dari 700 praktik di seluruh dunia telah menggunakan sistem mereka.",
            listCapability: [{
                tag: "Image",
                title: "Custom Image Classification",
                text: t("hpc4product4"),
                icon: aiic4,
                link: "/nlp"
            }],
        },
        {
            img: pb3, // TELKOM ACI
            judul: "Telkom ACI",
            text: 'Assessment Center',
            // link:  "learnmore",
            text1: "Revolusi Proses Rekrutmen dengan AI",
            text2: "Optimalkan proses wawancara dengan platform interview berbasis AI yang mampu mengonversi percakapan menjadi teks secara otomatis. ",
            img1: telkomaci1,
            impact: "Mempercepat proses assessment dalam seleksi pelamar berbagai event.",
            problem1: "Membutuhkan waktu yang lama dalam melakukan assessment",
            problem2: "Team ACI Telkom ingin mempercepat dan mempermudah salah satu proses requirement talenta dengan interview secara online.",
            solution1: "Mengembangkan sebuah platform interview secara online dengan memanfaatkan teknologi AI",
            solution2: "Dengan platform tersebut memudahkan team ACI dalam melakukan proses interview dan memberikan penilaian secara komprehensif.",
            img2: telkomaci2,
            background: "Assessment Center Indonesia (ACI) hadir sebagai bagian dari PT Telkom Indonesia (Persero) Tbk sejak tahun 1990, dan menjadi pelopor dalam penerapan metode Assessment Center di Indonesia. Metode ini merupakan yang terbaik dalam mengidentifikasi talenta unggulan perusahaan berdasarkan kriteria kompetensi yang dinilai melalui beberapa simulasi. ACI dengan konsisten menerapkan metode Assessment Center dan program pengembangan melalui Post Assessment Development (PAD) secara objektif dan transparan dalam semua prosesnya, untuk mencapai World Class People and Culture.",
            listCapability: [{
                tag: "Voice",
                title: "Speech to Text",
                text: t("hpc4product12"),
                icon: aiic1,
                link: "/nlp"
            }],
        },
        {
            img: pb6, // TELKOM SMARTSPEAKER
            judul: "Telkom Indonesia",
            text: 'Technology',
            // link:  "learnmore",
            text1: "Kontrol Perangkat dengan Suara, Lebih Mudah & Natural",
            text2: "Menghadirkan aplikasi mobile berbasis AI yang terintegrasi dengan speaker pintar, memungkinkan pengguna berinteraksi secara intuitif melalui perintah suara dalam bahasa sehari-hari",
            img1: telkom1,
            impact: "Kehadiran smart speaker dalam layanan Indihome memberikan nilai tambah bagi pelanggan, sekaligus meningkatkan efisiensi dan efektivitas produk serta layanan Indihome.",
            problem1: "AI Semakin Luas, Bisakah Kita Mengikutinya?",
            problem2: "Studi Gartner (2020) memprediksi bahwa dalam 5 tahun, 50% aktivitas akan diotomatisasi oleh AI. Banyak perusahaan besar telah memulai transformasi ini dengan mengembangkan layanan berbasis AI.",
            solution1: "Inovasi AI untuk Smart Speaker yang Lebih Pintar",
            solution2: "Kami menghadirkan aplikasi smart speaker berbasis AI yang memanfaatkan Speech-to-Text (STT) dan Text-to-Speech (TTS), memungkinkan interaksi suara yang lebih natural dan responsif.",
            img2: telkom2,
            background: "PT Telkom Indonesia (Persero) Tbk (Telkom) adalah BUMN yang bergerak di bidang teknologi informasi, komunikasi, dan telekomunikasi digital. Dalam upaya transformasi, TelkomGroup menerapkan strategi bisnis yang berfokus pada pelanggan, menjadikan organisasi lebih ramping dan gesit dalam menghadapi perubahan industri yang cepat. Dengan struktur baru ini, Telkom bertujuan meningkatkan efisiensi bisnis dan menghadirkan pengalaman pelanggan yang lebih baik.",
            listCapability: [{
                tag: "Voice",
                title: "Speech to Text",
                text: t("hpc4product12"),
                icon: aiic1,
                link: "/nlp"
            },{
                tag: "Voice",
                title: "Text to Speech",
                text: t("hpc4product11"),
                icon: aiic1,
                link: "/nlp"
            },],
        },
        {
            img: pb2, // MTF
            judul: "Mandiri Tunas Finance",
            text: 'Technology',
            // link:  "learnmore",
            text1: "Upgrade Company Profile & Security MTF",
            text2: "Tingkatkan Keamanan, Performa, & Pengalaman Digital",
            img1: mtf1,
            impact: "Dengan upgrade ini, MTF akan mengalami peningkatan dalam keamanan, kecepatan, dan pengalaman pengguna, serta memperluas jangkauan bisnisnya ke pasar internasional.",
            problem1: "🚨 Keamanan yang Rentan\n⏳ Kode Usang & Tidak Optimal\n🎨 Tampilan & UX Kurang Intuitif\n🌍 Tidak Ada Fitur Multi-Bahasa",
            problem2: "",
            solution1: "✅ Keamanan Maksimal\n✅ Website Lebih Modern & Responsif\n✅ Fitur Dual Language",
            solution2: "",
            img2: mtf2,
            background: "Mandiri Tunas Finance (MTF) adalah perusahaan pembiayaan di Indonesia yang menawarkan solusi keuangan mudah, inovatif, dan kompetitif untuk pembelian mobil baru, kendaraan niaga, serta pembiayaan multiguna bagi individu maupun korporasi.",
            listCapability: []
        },
    ]
    

    return(
        <>
            <Topbar/>

            <section className="demo">
                
                <div className="breadcrumbDemo"> 
                    <Link to={"/"}>Home</Link>
                    <img src={arrow} alt="arrow"></img>
                    <p style={{color: '#25874C', fontSize: '16px'}}>Demo</p>
                </div>

                <div className="intermezzoDemo">
                    <div className="topDemo">
                        <div className="dflex">
                            <img src="/photo/demoWomen.webp" style={{height: "auto", width: '70%'}} alt="women"  loading='eager' fetchPriority='high'></img>
                        </div>
                        <div>
                            <h1 className="fw800">{t("aisolutiontitle")}</h1>
                            <p>{t("aisolution1")}</p>
                        </div>
                        
                    </div>

                    <div className='listPictureDemo goneMobile'>
                        {listPicture.map((item, index) => (
                            <div key={index} style={{flex: '1'}}>
                                <img src={item.src} className={index === 0 ? 'leftBorder width100' : index === 3 ? 'rightBorder width100' : 'width100'} alt="listdemo"/>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="sectionDemo">
                    {/* <div className="listAIDemo goneMobile">
                        {listCapability1.map((item, index) => (
                            <div key={index} className="cardAIDemo"> 
                                <div>
                                    <div className="tagCardDemo">{item.tag}</div>
                                    <p className="titleCardDemo">{item.title}</p>
                                    <p className="textCardDemo">{item.text}</p>
                                </div>

                                <div className="mb24">
                                    <hr/>
                                    <div className="bottomCardDemo">
                                        <img src={item.icon} alt="icon"></img>
                                        <Link to={item.link} className="buttonSubmit" onClick={() => {document.body.scrollIntoView({behavior: "smooth"});}} >Try Demo</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="listAIDemo goneMobile">
                        {listCapability2.map((item, index) => (
                            <div key={index} className="cardAIDemo"> 
                                <div>
                                    <div className="tagCardDemo">{item.tag}</div>
                                    <p className="titleCardDemo">{item.title}</p>
                                    <p className="textCardDemo">{item.text}</p>
                                </div>

                                <div className="mb24">
                                    <hr/>
                                    <div className="bottomCardDemo">
                                        <img src={item.icon}  alt="icon"></img>
                                        <Link to={item.link} className="buttonSubmit" onClick={() => {document.body.scrollIntoView({behavior: "smooth"});}} >Try Demo</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="listAIDemo goneMobile">
                        {listCapability3.map((item, index) => (
                            <div key={index} className="cardAIDemo"> 
                                <div>
                                    <div className="tagCardDemo">{item.tag}</div>
                                    <p className="titleCardDemo">{item.title}</p>
                                    <p className="textCardDemo">{item.text}</p>
                                </div>

                                <div className="mb24">
                                    <hr/>
                                    <div className="bottomCardDemo">
                                        <img src={item.icon} alt="icon"></img>
                                        <Link to={item.link} className="buttonSubmit" onClick={() => {document.body.scrollIntoView({behavior: "smooth"});}} >Try Demo</Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> */}

                    <div className="listAIDemoMobile">
                        {listCapability.map((item, index) => (
                            <div className="cardDemoMobile">
                                <div className="cardTopMobile">
                                    <div>
                                        <img src={item.icon} alt="what?"/>
                                    </div>
                                    <p>{item.title}</p>
                                </div>
                                
                                <Link to={item.link} className="buttonGrayBorder" style={{textAlign: 'center', placeSelf: 'center'}} onClick={() => {document.body.scrollIntoView({behavior: "smooth"});}} >Try Demo</Link>

                            </div>
                        ))}
                    </div>

                    <div className="caseStudies">
                        <p className="caseTitle">Portfolio</p>
                        <div className="listCase">
                            {listCaseStudies.map((item, index) => (
                            <div key={index} className="cardListCase">
                                <div className="cardImgCase">
                                    <img src={item.img} alt="logostudy"/>
                                </div>
                                <div className="cardTextCase">
                                    <p className="judul">{item.judul}</p>
                                    <p className="text">{item.text}</p>
                                    <Link to={"/studycase"} state={{
                                        judul: item.judul,
                                        logo: item.img,
                                        text1: item.text1,
                                        text2: item.text2,
                                        img1: item.img1,
                                        impact: item.impact,
                                        problem1: item.problem1,
                                        problem2: item.problem2,
                                        solution1: item.solution1,
                                        solution2: item.solution2,
                                        img2: item.img2,
                                        background: item.background,
                                        listCapability: item.listCapability
                                    }} className="learnmore" onClick={() => {balikAtas()}} aria-label="Learn more about the website performance optimization study case">Explore</Link>
                                </div>
                            </div>
                            ))}
                        </div>
                    </div>
                </div>

            </section>

            <Footer/>
        </>
    )
}

export default Demo